import {atom, useSetRecoilState} from "recoil";
import {ReactNode} from "react";


interface alert_state_props {
    title?: string;
    message?: string;
    confirm?: Function;
    cancel?: Function;
}

export const alert_state = atom<alert_state_props>({
    key: "alert_state",
    default: {}
})

export const alert_show_state = atom<boolean>({
    key: "alert_show_state",
    default: false
})

export const useAlert = () => {
    const setAlert = useSetRecoilState(alert_state);
    const showAlert = useSetRecoilState(alert_show_state);

    return (title: string, message?: string, confirm?: Function, cancel?: Function) => {
        showAlert(true);
        setAlert({title, message, confirm, cancel})
    };
};

interface NotifyStateProps {
    title?: ReactNode;
    message?: string;
    confirm?: Function;
    cancel?: Function;
}

export const notify_state = atom<NotifyStateProps>({
    key: "notify_state",
    default: {}
});

export const notify_show_state = atom<boolean>({
    key: "notify_show_state",
    default: false
});

export const useNotify = () => {
    const setNotify = useSetRecoilState(notify_state);
    const showNotify = useSetRecoilState(notify_show_state);

    return (title: ReactNode, message?: string, confirm?: Function, cancel?: Function) => {
        showNotify(true);
        setNotify({title, message, confirm, cancel})
    };
};

export const loading_state = atom<boolean>({
    key: "loading_state",
    default: false
})


export const useLoading = () => {
    const setLoading = useSetRecoilState(loading_state);

    const startLoading = () => {
        setLoading(true)
    }
    const stopLoading = () => {
        setLoading(false);
    }

    return [startLoading, stopLoading];
}